<script lang="ts">
  import type { EnumT } from "@shared/schema"
  import SourceCard from "./SourceCard.svelte"

  export let value: EnumT.Source
</script>

<SourceCard nofocus readonly source={value} />
